<template>
    <div>
        <!--Start Middle content-->
        <!--Start internal page banner section-->
        <section class="internal-page-banner-main col-12">
            <div class="container">
                <div class="row">
                    <div class="page-title">
                        <h1> Employee Perks Program </h1>
                    </div>
                </div>
            </div>
        </section>
        <!--End internal page banner section-->
        <div class="internal-page-main-section col-12">
            <div class="container">
                <div class="row">
                    <template v-for="(discount, index) in discounts">
                        <template v-if="index == 0">
                            <div class="program-section-main col-12 float-l">
                                <!--first program-->
                                <div class="row">
                                    <template v-if="discount.discount_type != ''">
                                        <h2 class="heading-text-24 line-height-25 color-red font-text-bold-mont width-full float-l mb-30"> {{discount.discount_type}} </h2>
                                    </template>
                                    <template v-if="discount.image != ''">
                                        <div class="program-img-left col-12 col-sm-4 col-md-4 col-lg-4">
                                            <!--left section-->
                                            <div class="row">
                                                <div class="hover-home-eefect employee-border">
                                                    <img :src="discount.image" :alt="discount.discount_type">
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <!--left section-->
                                    <div class="program-img-right col-12 col-sm-8 col-md-8 col-lg-8">
                                        <!--right section-->
                                        <div class="row">
                                            <template v-if="discount.title != ''">
                                                <h3 class="color-blue heading-text-22 line-height-26 font-text-bold-mont width-full float-l pb-30"> {{discount.title}} </h3>
                                            </template>
                                            <!--<div v-html="raw" v-linkified />-->
                                            <template v-if="discount.description != ''">
                                                <!--<v-frame v-html="discount.description" text="VueJS" frame="idframe" type="iframe" class="description color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont width-full float-l pb-20"></v-frame>-->
                                                <p v-html="discount.description" class="description color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont width-full float-l pb-20"/>
                                                <!--<iframe v-html="discount.description"></iframe>-->
                                            </template>
                                            <template v-if="discount.instruction_title != ''">
                                                <p class="color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont width-full float-l pb-20 border-bottom-dddddd"> {{discount.instruction_title}} </p>
                                            </template>
                                            <template v-if="discount.instruction_count > 0">
                                                <div class="perks-program-list width-full float-l">
                                                    <ul>
                                                        <template v-for="(instr, key) in discount.instruction">
                                                            <li v-html="instr.step" v-linkified:options="{ className: 'color-333333' }" v-linkified class="mt-20 heading-text-16 line-height-20 color-333333" />
                                                        </template>
                                                    </ul>
                                                </div>
                                            </template>
                                            <template v-if="discount.phone_no !=''">
                                                <p class="color-blue heading-text-18 line-height-22 font-text-bold-mont width-full float-l mt-40"> Call : {{discount.phone_no}} </p>
                                            </template>
                                            <template v-if="discount.email !=''">
                                                <p class="color-blue heading-text-18 line-height-22 font-text-bold-mont width-full float-l mt-40"> Email : {{discount.email}} </p>
                                            </template>
                                            <template v-if="discount.discount_links_count > 0">
                                                <template v-for="(links, key) in discount.discount_links">
                                                    <template v-if="links.button_title !=''">
                                                        <p class="color-333333 heading-text-18 line-height-22 float-l width-full font-text-bold-mont pt-50">{{links.button_title}}</p>
                                                    </template>
                                                    <template v-if="links.button_text !='' || links.button_link != ''">
                                                        <div class="view-btn-small-big col-12 float-l mt-20">
                                                            <div class="row">
                                                                <template v-if="links.is_file == 1">
                                                                    <a href="#" :id="'id' + key" @click="getSignedUrlPath(links.button_link)" class="hvr-sweep-to-right-blue"> {{links.button_text}} </a>
                                                                </template>
                                                                <template v-else>
                                                                    <a :href="links.button_link" class="hvr-sweep-to-right-blue" target="_blank"> {{links.button_text}}</a>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <!-- <template v-if="links.button_text !='' || links.button_link != ''">
                                                        <div class="view-btn-small-big col-12 float-l mt-20">
                                                            <div class="row">
                                                                <a :href="links.button_link" class="hvr-sweep-to-right-blue" target="_blank"> {{links.button_text}} </a>
                                                            </div>
                                                        </div>
                                                    </template> -->

                                                </template>
                                            </template>

                                        </div>
                                    </div>
                                    <!--right section-->
                                </div>
                            </div>
                            <!--first program-->
                        </template>
                        <template v-else>
                            <div class="program-section-main col-12 float-l mt-70">
                                <!--program-->
                                <div class="row">
                                    <template v-if="discount.discount_type != ''">
                                        <h2 class="heading-text-24 line-height-25 color-red font-text-bold-mont width-full float-l mb-30"> {{discount.discount_type}} </h2>
                                    </template>
                                    <template v-if="discount.image != ''">
                                        <div class="program-img-left col-12 col-sm-4 col-md-4 col-lg-4">
                                            <!--left section-->
                                            <div class="row">
                                                <div class="hover-home-eefect employee-border">
                                                    <img :src="discount.image" :alt="discount.discount_type">
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <!--left section-->
                                    <div class="program-img-right col-12 col-sm-8 col-md-8 col-lg-8">
                                        <!--right section-->
                                        <div class="row">
                                            <template v-if="discount.title != ''">
                                                <h3 class="color-blue heading-text-22 line-height-26 font-text-bold-mont width-full float-l pb-30"> {{discount.title}} </h3>
                                            </template>
                                            <!--<div v-html="raw" v-linkified />-->
                                            <template v-if="discount.description != ''">
                                                <!--<v-frame v-html="discount.description" text="VueJS" frame="idframe" type="iframe" class="description color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont width-full float-l pb-20"></v-frame>-->
                                                <p v-html="discount.description" class="description color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont width-full float-l pb-20"/>
                                                <!--<iframe v-html="discount.description"></iframe>-->
                                            </template>
                                            <template v-if="discount.instruction_title != ''">
                                                <p class="color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont width-full float-l pb-20 border-bottom-dddddd"> {{discount.instruction_title}} </p>
                                            </template>
                                            <template v-if="discount.instruction_count > 0">
                                                <div class="perks-program-list width-full float-l">
                                                    <ul>
                                                        <template v-for="(instr, key) in discount.instruction">
                                                            <li v-html="instr.step" v-linkified:options="{ className: 'color-333333' }" v-linkified class="mt-20 heading-text-16 line-height-20 color-333333" />
                                                        </template>
                                                    </ul>
                                                </div>
                                            </template>
                                            <template v-if="discount.phone_no !=''">
                                                <p class="color-blue heading-text-18 line-height-22 font-text-bold-mont width-full float-l mt-40"> Call : {{discount.phone_no}} </p>
                                            </template>
                                            <template v-if="discount.email !=''">
                                                <p class="color-blue heading-text-18 line-height-22 font-text-bold-mont width-full float-l mt-40"> Email : {{discount.email}} </p>
                                            </template>
                                            <template v-if="discount.discount_links_count > 0">
                                                <template v-for="(links, key) in discount.discount_links">
                                                    <template v-if="links.button_title !=''">
                                                        <p class="color-333333 heading-text-18 line-height-22 float-l width-full font-text-bold-mont pt-50">{{links.button_title}}</p>
                                                    </template>
                                                    <template v-if="links.button_text !='' || links.button_link != ''">
                                                        <div class="view-btn-small-big col-12 float-l mt-20">
                                                            <div class="row">
                                                                <template v-if="links.is_file == 1">
                                                                    <a href="#" :id="'id' + key" @click="getSignedUrlPath(links.button_link)" class="hvr-sweep-to-right-blue"> {{links.button_text}} </a>
                                                                </template>
                                                                <template v-else>
                                                                    <a :href="links.button_link" class="hvr-sweep-to-right-blue" target="_blank"> {{links.button_text}}</a>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <!-- <template v-if="links.button_text !='' || links.button_link != ''">
                                                        <div class="view-btn-small-big col-12 float-l mt-20">
                                                            <div class="row">
                                                                <a :href="links.button_link" class="hvr-sweep-to-right-blue" target="_blank"> {{links.button_text}} </a>
                                                            </div>
                                                        </div>
                                                    </template> -->
                                                </template>
                                            </template>

                                        </div>
                                    </div>
                                    <!--right section-->
                                </div>
                            </div>
                            <!--program-->
                        </template>
                    </template>

                    <!--<div class="program-section-main col-12 float-l">
                        <div class="row">
                            <h2 class="heading-text-24 line-height-25 color-red font-text-bold-mont width-full float-l mb-30"> Seasonal Discounts </h2>
                            <div class="program-img-left col-12 col-sm-4 col-md-4 col-lg-4">
                                <div class="row">
                                    <div class="hover-home-eefect employee-border">
                                        <img src="/static/images/program-img-1.jpg" alt="Employee Perks Program">
                                    </div>
                                </div>
                            </div>
                            <div class="program-img-right col-12 col-sm-8 col-md-8 col-lg-8">
                                <div class="row">
                                    <h3 class="color-blue heading-text-22 line-height-26 font-text-bold-mont width-full float-l pb-30"> More to come…</h3>
                                    <p class="color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont width-full float-l pb-20 border-bottom-dddddd"> Online Ticket Instructions </p>
                                    <div class="perks-program-list width-full float-l">
                                        <ul>
                                            <li class="mt-20 heading-text-16 line-height-20 color-333333"> Visit <a class="color-333333" href="https://ticketsatwork.com/tickets/account.php?sub=enroll" target="_blank"> https://ticketsatwork.com/tickets/account.php?sub=enroll </a> </li>
                                            <li class="mt-20 heading-text-16 line-height-20 color-333333"> Sign up using VVGFUN as your corporate code. </li>
                                        </ul>
                                    </div>
                                    <p class="color-blue heading-text-18 line-height-22 font-text-bold-mont width-full float-l mt-40"> Call : (909) 623-3111 </p>
                                    <div class="view-btn-small-big col-12 float-l mt-25">
                                        <div class="row">
                                            <a href="http://lacountryfair.com/" class="hvr-sweep-to-right-blue" target="_blank"> LACountryFair.com </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>-->
                    <!--<div class="program-section-main col-12 float-l mt-70">
                        <div class="row">
                            <h2 class="heading-text-24 line-height-25 color-red font-text-bold-mont width-full float-l mb-30"> VVG Discounts </h2>
                            <div class="program-img-left col-12 col-sm-4 col-md-4 col-lg-4">
                                <div class="row">
                                    <div class="hover-home-eefect employee-border">
                                        <img src="/static/images/program-img-2.jpg" alt="VVG Discounts">
                                    </div>
                                </div>
                            </div>
                            <div class="program-img-right col-12 col-sm-8 col-md-8 col-lg-8">
                                <div class="row">
                                    <h3 class="color-blue heading-text-22 line-height-26 font-text-bold-mont width-full float-l pb-30"> Exclusive Employee Discounts </h3>
                                    <p class="color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont width-full float-l"> We will provide instructions for access once vendor sets up our company codes. </p>
                                    <p class="color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont width-full float-l pt-50"> Click Become a Member </p>
                                    <a class="color-blue heading-text-18 line-height-20 float-l width-full font-text-semi-medium-mont pt-10" href="https://ticketsatwork.com/tickets/account.php?sub=enroll" target="_blank"> https://ticketsatwork.com/tickets/account.php?sub=enroll </a>
                                    <p class="color-333333 heading-text-18 line-height-22 float-l width-full font-text-bold-mont pt-50"> Tickets at Work </p>
                                    <div class="view-btn-small-big col-12 float-l mt-15">
                                        <div class="row">
                                            <a href="https://www.ticketsatwork.com/tickets/" class="hvr-sweep-to-right-blue" target="_blank"> www.ticketsatwork.com </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>-->
                    <!--<div class="program-section-main col-12 float-l mt-70">
                        <div class="row">
                            <h2 class="heading-text-24 line-height-25 color-red font-text-bold-mont width-full float-l mb-30"> Fitness Discounts </h2>
                            <div class="program-img-left col-12 col-sm-4 col-md-4 col-lg-4">
                                <div class="row">
                                    <div class="hover-home-eefect employee-border">
                                        <img src="/static/images/program-img-3.jpg" alt="Fitness Discounts">
                                    </div>
                                </div>
                            </div>
                            <div class="program-img-right col-12 col-sm-8 col-md-8 col-lg-8">
                                <div class="row">
                                    <h3 class="color-blue heading-text-22 line-height-26 font-text-bold-mont width-full float-l pb-30"> Kaiser Covered Employees choose Discounts </h3>
                                    <p class="color-333333 heading-text-20 line-height-24 font-text-bold-mont width-full float-l pb-20 "> Kaiser Covered Employees can choose from over <span class="color-red"> 9,000 fitness centers </span> for <span class="color-red"> $25 </span> month </p>
                                    <div class="perks-program-list width-full float-l">
                                        <ul>
                                            <li class="mt-20 heading-text-16 line-height-20 color-333333"> Click “Register” on the top right. </li>
                                            <li class="mt-20 heading-text-16 line-height-20 color-333333"> You can also call 877-335-2746 to learn more! </li>
                                        </ul>
                                    </div>
                                    <div class="view-btn-small-big col-12 float-l mt-65">
                                        <div class="row">
                                            <a href="http://www.choosehealthy.com/" class="hvr-sweep-to-right-blue" target="_blank"> www.choosehealthy.com </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>-->
                    <!--<div class="program-section-main col-12 float-l mt-70">
                        <div class="row">
                            <h2 class="heading-text-24 line-height-25 color-red font-text-bold-mont width-full float-l mb-30"> Phone Carrier Discounts </h2>
                            <div class="program-img-left col-12 col-sm-4 col-md-4 col-lg-4">
                                <div class="row">
                                    <div class="hover-home-eefect employee-border">
                                        <img src="/static/images/program-img-4.jpg" alt="Phone Carrier Discounts">
                                    </div>
                                </div>
                            </div>
                            <div class="program-img-right col-12 col-sm-8 col-md-8 col-lg-8">
                                <div class="row">
                                    <h3 class="color-blue heading-text-22 line-height-26 font-text-bold-mont width-full float-l pb-30"> Spread the World! </h3>
                                    <p class="color-333333 heading-text-20 line-height-24 font-text-bold-mont width-full float-l pb-10 "> ATT – 22% Discount for Transwest Truck Center, LLC Employees </p>
                                    <p class="color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont width-full float-l"> On their qulified monthly service charges with AT&T. </p>
                                    <p class="color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont width-full float-l mt-20"> Take a reminder and share it with a coworker to get started. </p>
                                    <p class="color-333333 heading-text-20 line-height-24 font-text-bold-mont width-full float-l mt-40"> Verizon – 8 % Discount for Los Angeles Truck Centers, LLC Employees </p>
                                    <div class="view-btn-small-big col-12 float-l mt-65">
                                        <div class="row">
                                            <a href="https://www.velocityvehiclegroup.com/" class="hvr-sweep-to-right-blue" target="_blank"> www.velocityvehiclegroup.com </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>-->
                    <!--<div class="program-section-main col-12 float-l mt-70">
                        <div class="row">
                            <h2 class="heading-text-24 line-height-25 color-red font-text-bold-mont width-full float-l mb-30"> Southland Credit Union </h2>
                            <div class="program-img-left col-12 col-sm-4 col-md-4 col-lg-4">
                                <div class="row">
                                    <div class="hover-home-eefect employee-border">
                                        <img src="/static/images/program-img-5.jpg" alt="Phone Carrier Discounts">
                                    </div>
                                </div>
                            </div>
                            <div class="program-img-right col-12 col-sm-8 col-md-8 col-lg-8">
                                <div class="row">
                                    <p class="color-333333 heading-text-20 line-height-24 font-text-bold-mont width-full float-l"> Vehicle Loan Discount <span class="font-text-semi-medium-mont"> (doc on bulletin board) </span> </p>
                                    <div class="view-btn-small-big col-12 float-l mt-20">
                                        <div class="row">
                                            <a href="https://www.velocityvehiclegroup.com/hr" class="hvr-sweep-to-right-blue" target="_blank"> www.velocityvehiclegroup.com/hr </a>
                                        </div>
                                    </div>
                                    <p class="color-333333 heading-text-20 line-height-24 font-text-bold-mont width-full float-l mt-45"> Mortgage Discounts <span class="font-text-semi-medium-mont"> (doc on bulletin board) </span> </p>
                                    <div class="view-btn-small-big col-12 float-l mt-20">
                                        <div class="row">
                                            <a href="https://www.velocityvehiclegroup.com/hr" class="hvr-sweep-to-right-blue" target="_blank"> www.velocityvehiclegroup.com/hr </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>-->
                    <!--<div class="program-section-main col-12 float-l mt-70">
                        <div class="row">
                            <h2 class="heading-text-24 line-height-25 color-red font-text-bold-mont width-full float-l mb-30"> Discounts for Attractions </h2>
                            <div class="program-img-left col-12 col-sm-4 col-md-4 col-lg-4">
                                <div class="row">
                                    <div class="hover-home-eefect employee-border">
                                        <img src="/static/images/fun-express.jpg" alt="Phone Carrier Discounts">
                                    </div>
                                </div>
                            </div>
                            <div class="program-img-right col-12 col-sm-8 col-md-8 col-lg-8">
                                <div class="row">
                                    <h3 class="color-blue heading-text-22 line-height-26 font-text-bold-mont width-full float-l pb-30"> Fun Express </h3>
                                    <p class="color-333333 heading-text-16 line-height-22 font-text-semi-medium-mont width-full float-l">Please check out Fun Express at <a class="color-blue" href="https://funex.com/" target="_blank"> https://funex.com/ </a> . If you shop by web, you do not need to login to browse the site. <span class="font-text-bold-mont"> If you decide to make a purchase, use our Employee Activity Code (EAC) to register yourself with our company, and qualify for the great discounts! Our Employee Access Code is: <b class="color-red"> 12-19860. </b> </span>                                    </p>
                                    <p class="color-333333 heading-text-20 line-height-24 font-text-bold-mont width-full float-l mt-90"> Doc Download available on HR Bulletin board</p>
                                    <div class="view-btn-small-big col-12 float-l mt-20">
                                        <div class="row">
                                            <a href="https://www.velocityvehiclegroup.com/hr" class="hvr-sweep-to-right-blue" target="_blank"> www.velocityvehiclegroup.com/hr </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>-->
                </div>
            </div>
        </div>
        <!--End Middle content-->
    </div>
</template>
<script>
    import Vue from "vue";
    import VueFrame from 'vue-frame';
    import SessioMixin from '../mixins/sessionmixin';
    import { HTTP } from '../http-common';
    var self;
    export default {
        name: 'Employee_Parks_Program',
        mixins: [SessioMixin],
        components: {
            'v-frame': VueFrame,
        },
        data() {
            return {
                raw: 'Visit https://ticketsatwork.com/tickets/account.php?sub=enroll',
                discounts: [],
            }
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },
        mounted: function () {
            self.MenuClose();
            self.loadDiscounts();
            self.getBuildVersion();
        },
        methods: {
            loadDiscounts: function () {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var fields = {
                };
                HTTP.post('displaydiscount', fields, config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.discounts = response.data.content;
                            }

                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        self.$router.push("/login");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    }
                                    self.error = err.response.data.message;
                                }
                            }
                        })
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/EmployeePerksProgram.vue